import o from "./getPrototypeOf.mjs";
import f from "./isNativeReflectConstruct.mjs";
import i from "./possibleConstructorReturn.mjs";
function c(e) {
  var n = f();
  return function() {
    var r = o(e), t;
    if (n) {
      var s = o(this).constructor;
      t = Reflect.construct(r, arguments, s);
    } else
      t = r.apply(this, arguments);
    return i(this, t);
  };
}
export {
  c as default
};
//# sourceMappingURL=createSuper.mjs.map
